import layoutHeaderAside from '@/layout/header-aside'
import bus from '@/components/view-bus'

const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 信鸽路由
export default [
  {
    path: '/pigeon',
    name: 'Pigeon',
    meta: {
      title: '赛事',
      auth: true
    },
    // redirect: { name: 'MatchContent' },
    component: layoutHeaderAside,
    children: [
      {
        path: 'prepay',
        name: 'PrePayIndex',
        meta: {
          title: '会员预定',
          auth: true
        },
        component: _import('payfee/prepay')
      },
      {
        path: 'deleteOrder',
        name: 'deleteOrder',
        meta: {
          title: '一键作废名单',
          auth: true
        },
        component: _import('payfee/advance/deleteOrder')
      },
      {
        path: 'collectPigeon',
        name: 'collectPigeon',
        meta: {
          title: '赛鸽管理',
          auth: true
        },
        component: _import('match/components/collect-pigeon')
      },
      {
        path: 'pigeonUser',
        name: 'pigeonUser',
        meta: {
          title: '鸽主管理',
          auth: true
        },
        component: _import('member/pigeon-user')
      },
      {
        path: 'agency',
        name: 'Agency',
        meta: {
          title: '代理管理',
          auth: true
        },
        redirect: { name: 'agencyuser' },
        component: bus,
        children: [
          {
            path: 'agencyuser',
            name: 'agencyuser',
            meta: {
              title: '代理管理',
              auth: true
            },
            component: _import('member/agency-user')
          },
          {
            path: 'agencyAdd',
            name: 'agencyAdd',
            meta: {
              title: '新建代理',
              auth: true
            },
            component: _import('member/component/agency-info')
          },
          {
            path: 'agencyEdit',
            name: 'agencyEdit',
            meta: {
              title: '编辑代理',
              auth: true
            },
            component: _import('member/component/agency-info')
          }
        ]
      },
      {
        path: 'index',
        name: 'PigeonIndex',
        meta: {
          title: '收鸽登记',
          auth: true
        },
        redirect: { name: 'PigeonList' },
        component: bus,
        children: [
          {
            path: 'list',
            name: 'PigeonList',
            meta: {
              title: '收鸽列表',
              auth: true
            },
            component: _import('pigeon/pigeon')
          },
          {
            path: 'collect',
            name: 'PigeonCollect',
            meta: {
              title: '集鸽详情',
              auth: true
            },
            component: _import('pigeon/collect')
          },
          {
            path: 'grade',
            name: 'PigeonGrade',
            meta: {
              title: '成绩详情',
              auth: true
            },
            component: _import('pigeon/grade')
          },
          {
            path: 'pigeonAdd',
            name: 'PigeonAdd',
            meta: {
              title: '新建信鸽',
              auth: true
            },
            component: _import('pigeon/pigeon-add')
          },
          {
            path: 'pigeonEdit',
            name: 'PigeonEdit',
            meta: {
              title: '编辑信鸽',
              auth: true
            },
            component: _import('pigeon/pigeon-info')
          }
        ]
      },
      // {
      //   path: 'intention',
      //   name: 'PigeonIntention',
      //   meta: {
      //     title: '交鸽意向',
      //     auth: true
      //   },
      //   component: _import('pigeon/intention')
      // },
      {
        path: 'notice',
        name: 'PigeonNotice',
        meta: {
          title: '短信发送记录',
          auth: true
        },
        component: _import('pigeon/pigeon-notice-list')
      },
      {
        path: 'matchContent',
        name: 'matchContent',
        meta: {
          title: '赛事详情',
          auth: true
        },
        // component: _import('match/match-content3'),
        component: bus,
        // redirect: { name: 'collectPigeon' },
        children: [
          // {
          //   path: '',
          //   component: _import('match/match-content3')
          // },
          // {
          //   path: 'collectPigeon',
          //   name: 'collectPigeon',
          //   meta: {
          //     title: '收鸽',
          //     auth: true
          //   },
          //   component: _import('match/components/collect-pigeon')
          // },
          // {
          //   path: 'pigeonUser',
          //   name: 'pigeonUser',
          //   meta: {
          //     title: '鸽主',
          //     auth: true
          //   },
          //   component: _import('match/components/pigeon-user')
          // },
          // {
          //   path: 'newCourse',
          //   name: 'newCourse',
          //   meta: {
          //     title: '赛程',
          //     auth: true
          //   },
          //   component: _import('match/components/new-course')
          // },
          // {
          //   path: 'matchItem',
          //   name: 'matchItem',
          //   meta: {
          //     title: '赛项',
          //     auth: true
          //   },
          //   component: _import('match/components/match-item')
          // },
          {
            path: 'videoVisitation',
            name: 'videoVisitation',
            meta: {
              title: '探视',
              auth: true
            },
            component: _import('match/components/video-components')
          },
          {
            path: 'xunSai',
            name: 'xunSai',
            meta: {
              title: '训赛',
              auth: true
            },
            component: _import('match/components/xunSai')
          },
          {
            path: 'assignContent',
            name: 'assignContent',
            meta: {
              title: '养训技能赛',
              auth: true
            },
            component: _import('assign/match/assign-content')
          },
          {
            path: 'awardContent',
            name: 'awardContent',
            meta: {
              title: '奖金赛',
              auth: true
            },
            component: _import('award/award-match')
          }
        ]

      },
      {
        path: 'match',
        name: 'Match',
        meta: {
          title: '赛事管理',
          auth: true
        },
        redirect: { name: 'MatchIndex' },
        component: bus,
        children: [
          {
            path: 'pigeonFromList',
            name: 'PigeonFromList',
            meta: {
              title: '收鸽单列表',
              auth: true
            },
            component: _import('match/pigeonFromList')
          },
          {
            path: 'pigeonFromEdit',
            name: 'PigeonFromEdit',
            meta: {
              title: '收鸽单编辑',
              auth: true
            },
            component: _import('match/pigeonFromUpdate')
          },
          {
            path: 'pigeonFromCreate',
            name: 'PigeonFromCreate',
            meta: {
              title: '收鸽单录入',
              auth: true
            },
            component: _import('match/pigeonFromUpdate')
          },
          {
            path: 'Checkthelistofpigeons',
            name: 'Checkthelistofpigeons',
            meta: {
              title: '收鸽单详情',
              auth: true
            },
            component: _import('match/Checkthelistofpigeons')
          },
          {
            path: 'round',
            name: 'Round',
            meta: {
              title: '赛次管理',
              auth: true
            },
            redirect: { name: 'RoundIndex' },
            component: bus,
            children: [
              {
                path: 'index',
                name: 'RoundIndex',
                meta: {
                  title: '赛次详情',
                  auth: true
                },
                component: _import('match/components/round-info')
              },
              {
                path: 'sumSuccess',
                name: 'SumSuccess',
                meta: {
                  title: '各关成绩汇总',
                  auth: true
                },
                component: _import('match/components/sum-success')
              },
              // {
              //   path: 'xf',
              //   name: 'RoundXf',
              //   meta: {
              //     title: '训放详情',
              //     auth: true
              //   },
              //   component: _import('match/components/xf-info')
              // },
              {
                path: 'bonus',
                name: 'RoundBonus',
                meta: {
                  title: '奖金管理',
                  auth: true
                },
                component: _import('match/bonus')
              },
              {
                path: 'weather',
                name: 'Weather',
                meta: {
                  title: '赛线管理',
                  auth: true
                },
                component: _import('match/weather')
              },
              {
                path: 'Rcollect',
                name: 'RoundCollect',
                meta: {
                  title: '集鸽详情',
                  auth: true
                },
                component: _import('match/collect')
              },
              {
                path: 'Rgrade',
                name: 'RoundGrade',
                meta: {
                  title: '成绩详情',
                  auth: true
                },
                component: _import('match/grade')
              }
            ]
          }
        ]
      },
      {
        path: 'auction',
        name: 'Auction',
        meta: {
          title: '赛事拍卖管理',
          auth: true
        },
        redirect: { name: 'AuctionIndex' },
        component: bus,
        children: [
          {
            path: 'index',
            name: 'AuctionIndex',
            meta: {
              title: '赛事拍卖管理',
              auth: true
            },
            component: _import('pigeon/auction')
          },
          {
            path: 'detail',
            name: 'AuctionDetail',
            meta: {
              title: '赛事拍卖详情',
              auth: true
            },
            component: _import('pigeon/auctionDetail')
          },
          {
            path: 'auctionPigeonInfo',
            name: 'AuctionPigeonInfo',
            meta: {
              title: '拍鸽详情',
              auth: true
            },
            component: _import('pigeon/auction-pigeon-info')
          },
          {
            path: 'auctionList',
            name: 'AuctionList',
            meta: {
              title: '拍卖列表',
              auth: true
            },
            component: _import('pigeon/auction-list')
          },
          {
            path: 'auctionManual',
            name: 'auctionManual',
            meta: {
              title: '拍卖手册',
              auth: true
            },
            component: _import('pigeon/auctionManual')
          },
          {
            path: 'auctionSet',
            name: 'auctionSet',
            meta: {
              title: '拍卖设置',
              auth: true
            },
            component: _import('pigeon/auctionSet')
          }
        ]
      },
      {
        path: 'matchAssign',
        name: 'MatchAssign',
        meta: {
          title: '技能赛管理',
          auth: true
        },
        component: _import('assign/match/assign-list')
      },
      {
        path: 'matchAssignAdd',
        name: 'MatchAssignAdd',
        meta: {
          title: '技能赛设置',
          auth: true
        },
        component: _import('assign/match/add-assign')
      },
      {
        path: 'matchAssignInfo',
        name: 'MatchAssignInfo',
        meta: {
          title: '技能赛明细',
          auth: true
        },
        component: _import('assign/match/new-assign-info.vue')
      },
      {
        path: 'assignWeb',
        name: 'AssignWeb',
        meta: {
          title: '网络技能赛',
          auth: true
        },
        component: _import('assign/match/online-list.vue')
      },
      {
        path: 'matchAssignInfoNo',
        name: 'MatchAssignInfoNo',
        meta: {
          title: '技能赛未上笼',
          auth: true
        },
        component: _import('assign/match/new-assign-info-no-2.vue')
      },
      {
        path: 'matchAssignOrder',
        name: 'MatchAssignOrder',
        meta: {
          title: '技能赛下单',
          auth: true
        },
        component: _import('assign/match/new-assign-order')
      },
      {
        path: 'assignStatistics',
        name: 'assignStatistics',
        meta: {
          title: '技能赛统计',
          auth: true
        },
        component: _import('assign/match/assign-statistics')
      },
      {
        path: 'bonusSum',
        name: 'BonusSum',
        meta: {
          title: '奖金核算',
          auth: true
        },
        component: _import('assign/match/bonus-sum')
      },
      {
        path: 'orderhistory',
        name: 'orderhistory',
        meta: {
          title: '技能赛日志',
          auth: true
        },
        component: _import('assign/match/orderhistory')
      },
      {
        path: 'awardStatistics',
        name: 'AwardStatistics',
        meta: {
          title: '奖金统计',
          auth: true
        },
        component: _import('assign/match/award-statistics')
      },
      {
        path: 'rulesSetting',
        name: 'rulesSetting',
        meta: {
          title: '规则设置',
          auth: true
        },
        component: _import('assign/match/rules-setting')
      },
      {
        path: 'matchXi',
        name: 'matchXi',
        meta: {
          title: '赛事报名',
          auth: true
        },
        component: _import('award/match-xi')
      },
      {
        path: 'matchOneMore',
        name: 'matchOneMore',
        meta: {
          title: '赛事报名',
          auth: true
        },
        component: _import('award/match-onemore')
      },
      {
        path: 'matchZi',
        name: 'matchZi',
        meta: {
          title: '赛事报名',
          auth: true
        },
        component: _import('award/match-zi')
      },
      {
        path: 'matchNav',
        name: 'MatchNav',
        meta: {
          title: '赛事报名',
          auth: true
        },
        component: _import('award/match-nav')
      },
      {
        path: 'matchlistold',
        name: 'MatchList',
        meta: {
          title: '赛事报名',
          auth: true
        },
        component: _import('award/match-list')
      },
      {
        path: 'cost',
        name: 'Cost',
        meta: {
          title: '交费退费',
          auth: true
        },
        component: _import('award/cost')
      },
      {
        path: 'rule',
        name: 'Rule',
        meta: {
          title: '规则设置',
          auth: true
        },
        component: _import('award/rule')
      },
      {
        path: 'account',
        name: 'Account',
        meta: {
          title: '成绩及奖金',
          auth: true
        },
        component: _import('award/account')
      },
      {
        path: 'group',
        name: 'Group',
        meta: {
          title: '分组',
          auth: true
        },
        component: _import('award/group')
      },
      {
        path: 'onlineSet',
        name: 'onlineSet',
        meta: {
          title: '报名设置',
          auth: true
        },
        component: _import('new-pub/SignUpSet')
      },
      {
        path: 'onlineOrder',
        name: 'onlineOrder',
        meta: {
          title: '网络报名订单',
          auth: true
        },
        component: _import('award/onlineOrder')
      },
      {
        path: 'statistic',
        name: 'statistic',
        meta: {
          title: '报名统计',
          auth: true
        },
        component: _import('award/statistic')
      },
      {
        path: 'baozhengjin',
        name: 'baozhengjin',
        meta: {
          title: '预定金抵扣',
          auth: true
        },
        component: _import('award/baozhengjin')
      },
      {
        path: 'unPaid',
        name: 'unPaid',
        meta: {
          title: '未交费名单',
          auth: true
        },
        component: _import('award/unPaid')
      },
      {
        path: 'unPaidDetail',
        name: 'unPaidDetail',
        meta: {
          title: '未交费羽数',
          auth: true
        },
        component: _import('award/unPaidDetail')
      },
      {
        path: 'groupstatistic',
        name: 'groupstatistic',
        meta: {
          title: '分组统计',
          auth: true
        },
        component: _import('award/groupStatistic')
      },
      {
        path: 'orderLog',
        name: 'orderLog',
        meta: {
          title: '下单日志',
          auth: true
        },
        component: _import('award/orderLog')
      },
      {
        path: 'onlineRecord',
        name: 'onlineRecord',
        meta: {
          title: '在线预约记录',
          auth: true
        },
        component: _import('match/components/online-record')
      }

    ]
  }
]
